import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import { getTopper } from "../Service/Api";
import LazyLoad from "react-lazyload";

const Toppers = () => {
  useEffect(() => {
    document.title = "Toppers X - Hill Top School, Jamshedpur";
  }, []);

  const [data, setData] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [yearRanges, setYearRanges] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const toppersData = await getTopper();

      // get all session years sorted (latest first)
      const years = [...new Set(toppersData.map(item => item.sessionYear))].sort(
        (a, b) => b.localeCompare(a)
      );

      setYearRanges(years);

      // ✅ CURRENT YEAR (latest from API)
      let activeYear = years[0];

      let filteredData = toppersData.filter(
        item => item.sessionYear === activeYear && item.class === "X"
      );

      // ✅ FALLBACK to previous year if no data
      if (filteredData.length === 0 && years[1]) {
        activeYear = years[1];
        filteredData = toppersData.filter(
          item => item.sessionYear === activeYear && item.class === "X"
        );
      }

      setSelectedYear(activeYear);
      setData(filteredData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleYearChange = (e) => {
    const year = e.target.value;
    setSelectedYear(year);

    getTopper().then((toppersData) => {
      const filtered = toppersData.filter(
        (item) => item.sessionYear === year && item.class === "X"
      );
      setData(filtered);
    });
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  return (
    <>
      <Header />

      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>
          </li>
          <li>Toppers ICSE</li>
        </ul>
      </div>

      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Toppers ICSE</h1>
            </div>
          </div>

          <div className="row tabs-dynamic">
            <div className="col-md-6">
              <div className="month-selection">
                <select
                  id="yearSelection"
                  onChange={handleYearChange}
                  value={selectedYear}
                >
                  <option value="All">Select Years</option>
                  {yearRanges.map((yr, index) => (
                    <option key={index} value={yr}>
                      {yr}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-md-6">
              <div className="searchBox">
                <input
                  type="text"
                  placeholder="Search Here.."
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
              </div>
            </div>
          </div>

          <div className="row">
            {data.length > 0 ? (
              data.map((item, index) => (
                <div className="col-xl-3 col-lg-4 col-md-4 col-6" key={index}>
                  <div className="toppers-inner">
                    <LazyLoad
                      offset={10}
                      placeholder={
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/HTSJ/public/Images/trophy.png"
                          alt="Loading..."
                          className="img-fluid"
                        />
                      }
                    >
                      <img
                        src={
                          item.attachments && item.attachments[0]
                            ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`
                            : "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/HTSJ/public/Images/trophy.png"
                        }
                        className="img-fluid"
                        alt="Hill Top School, Jamshedpur"
                      />
                    </LazyLoad>

                    <h3>{item.name}</h3>
                    <p>{item.stream}</p>
                    <h5>{item.division}</h5>
                  </div>
                </div>
              ))
            ) : (
              <p></p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Toppers;